import { ETPermissions } from './base.constants';

export const EJOURNAL_ALLOWED_PERMISSIONS = [
  ETPermissions.NotarySigningAgent,
  ETPermissions.TitleSigningAgent,
  ETPermissions.Title,
] as const;

export function isEjournalAllowedUserType(
  userType: string | undefined,
): boolean {
  return (
    !!userType &&
    (EJOURNAL_ALLOWED_PERMISSIONS as readonly string[]).includes(userType)
  );
}

export type IdentificationMethod =
  | 'identification_cards'
  | 'personal_knowledge'
  | 'credible_witnesses';

export const IDENTIFICATION_METHOD_OPTIONS: Array<{
  value: IdentificationMethod;
  label: string;
}> = [
  {
    value: 'identification_cards',
    label: 'Identification Cards',
  },
  {
    value: 'personal_knowledge',
    label: 'Personal Knowledge',
  },
  {
    value: 'credible_witnesses',
    label: 'Credible Witnesses',
  },
];
